var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app-bar",
    { attrs: { app: "", color: "primary", dark: "" } },
    [_vm._t("bar-nav-icon")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }